import axios from 'axios';
import { QContext, REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';
import { QVaultFolder } from 'data/models/QVault';

export const getQVaultDefaultFoldersForPartner = async (partnerId: number): Promise<QVaultFolder[]> => {
  const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/qVaultFolder?partnerId=${partnerId}`);
  return response.data.data;
};

export const createNewQVaultDefaultFolder = async (partnerId: number, name: string): Promise<QVaultFolder[]> => {
  const newDefaultFolder: QVaultFolder = {
    partnerId: partnerId,
    folderName: name,
    isInternal: false,
    isEnabled: true,
    isHidden: false,
  };
  const response = await axios.post(`${REACT_APP_QWEALTH_API_V3}/qVaultFolder`, newDefaultFolder);
  return response.data.data;
};

export const updateExistingQVaultDefaultFolder = async (
  updatedFolder: QVaultFolder,
  isEnabled: boolean,
  isHidden: boolean,
): Promise<QVaultFolder> => {
  const payload: QVaultFolder = { ...updatedFolder, isEnabled: isEnabled, isHidden: isHidden };
  const response = await axios.patch(`${REACT_APP_QWEALTH_API_V3}/qVaultFolder/${updatedFolder.id}`, payload);
  return response.data.data;
};
